import {
  dashboardColor,
  globeColor,
  archiveColor,
  postmasterColor,
  customizationsColor,
  delegateColor,
  importsColor,
  migrationsColor,
  etliveColor,
  supportColor,
  registerColor,
  emailDelivery,
  users,
  suppressionList,
} from "Icons/index";

function goToCustomizationSupport(manager) {
  let win = window.open("about:blank", "_blank");
  win.focus();
  win.location.replace(manager.customization_help_desk_url);
}

export default (manager, router, isDelivery = false) => {
  if (isDelivery) {
    return [
      { category: "", links: [{ path: "/delivery", label: "sidebar.item.emailDelivery", icon: emailDelivery }] },
      {
        category: "sidebar.category.management",
        links: [
          { path: "/delivery/accounts", label: "sidebar.item.emailDelivery.accounts", icon: users },
          { path: "/delivery/domains", label: "sidebar.item.domains", icon: globeColor },
          {
            path: "/delivery/suppression-list",
            label: "sidebar.item.emailDelivery.suppressionList",
            icon: suppressionList,
          },
        ],
      },

      {
        category: "sidebar.category.analysis",
        links: [{ path: "/delivery/tracemail", label: "sidebar.item.etlive", icon: etliveColor }],
      },
    ];
  }

  let routes = [
    { category: "", links: [{ path: "/home", label: "sidebar.item.dashboard", icon: dashboardColor }] },
    {
      category: "sidebar.category.management",
      links: [
        { path: "/domains", label: "sidebar.item.domains", icon: globeColor },
        { path: "/archive", label: "sidebar.item.archive", icon: archiveColor },
        { path: "/customizations", label: "sidebar.item.customizations", icon: customizationsColor },
      ],
    },
    {
      category: "sidebar.category.roles",
      links: [
        { path: "/postmasters", label: "sidebar.item.postmasters", icon: postmasterColor },
        { path: "/delegates", label: "sidebar.item.delegates", icon: delegateColor },
      ],
    },
    {
      category: "sidebar.category.importsMigrations",
      links: [
        { path: "/imports", label: "sidebar.item.imports", icon: importsColor },
        { path: "/migrations", label: "sidebar.item.migrations", icon: migrationsColor },
      ],
    },
    {
      category: "sidebar.category.analysis",
      links: [
        { path: "/tracemail", label: "sidebar.item.etlive", icon: etliveColor, newFeature: false },
        { path: "/audits", label: "sidebar.item.auditLogs", icon: registerColor },
      ],
    },
  ];

  if (manager.customization_help_desk_url) {
    routes.push({
      category: "",
      links: [
        {
          label: "sidebar.item.support",
          icon: supportColor,
          action: () => goToCustomizationSupport(manager),
        },
      ],
    });
  }

  return routes;
};
